import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/AuthContext";
import { LocationProvider } from "@/lib/LocationContext";
import CryptoTicker from "@/components/CryptoTicker";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import CategoriesPage from "@/pages/Categories";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Bookmarks from "@/pages/Bookmarks";
import Search from "@/pages/Search";
import Admin from "@/pages/Admin";
import Submit from "@/pages/Submit";
import Leaderboard from "@/pages/Leaderboard";
import Preferences from "@/pages/Preferences";
import Unsubscribed from "@/pages/Unsubscribed";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Merchant from "@/pages/Merchant";
import Follows from "@/pages/Follows";
import DealDetail from "@/pages/DealDetail";
import Referrals from "@/pages/Referrals";
import Wishlists from "@/pages/Wishlists";
import PublicWishlist from "@/pages/PublicWishlist";
import Curator from "@/pages/Curator";
import AuthCallback from "@/pages/AuthCallback";
import RefCapture from "@/components/RefCapture";
import PendingSaveHandler from "@/components/PendingSaveHandler";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LocationProvider>
            <RefCapture />
            <PendingSaveHandler />
            <CryptoTicker />
            <Navbar />
            <main className="min-h-[70vh]">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/category/:slug" element={<Category />} />
                <Route path="/search" element={<Search />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/bookmarks" element={<Bookmarks />} />
                <Route path="/submit" element={<Submit />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/preferences" element={<Preferences />} />
                <Route path="/unsubscribed" element={<Unsubscribed />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/merchant/:name" element={<Merchant />} />
                <Route path="/follows" element={<Follows />} />
                <Route path="/deals/:id" element={<DealDetail />} />
                <Route path="/referrals" element={<Referrals />} />
                <Route path="/wishlists" element={<Wishlists />} />
                <Route path="/w/:slug" element={<PublicWishlist />} />
                <Route path="/curator" element={<Curator />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" richColors closeButton />
          </LocationProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
